import { render, staticRenderFns } from "./snb-org-profile.vue?vue&type=template&id=3fae2461&scoped=true&"
import script from "./snb-org-profile.vue?vue&type=script&lang=tsx&"
export * from "./snb-org-profile.vue?vue&type=script&lang=tsx&"
import style0 from "./snb-org-profile.vue?vue&type=style&index=0&id=3fae2461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fae2461",
  null
  
)

export default component.exports